import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { TOrganization } from '~/features/organizations/models'
import queryKeys from '~/features/organizations/utils'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import pathBuilder from '~/utils/api'

const useGetOrganization = (
  organizationId: string,
  options?: Partial<UseQueryOptions<HttpServiceBaseResponse<TOrganization>>>,
) => {
  return useQuery({
    enabled: !!organizationId,
    queryKey: queryKeys.organization(organizationId),
    queryFn: () =>
      HttpService.get<TOrganization>({
        path: pathBuilder(EServerPath.organization, { id: organizationId }),
      }),
    ...options,
  })
}

export default useGetOrganization
